<template>
  <van-overlay show z-index="1000">
    <div class="w-full h-full bg-white">
      <div class="px-5" style="padding-top: 30vh">
        <div class="text-center">
          <span>应发布人要求，必须授权地理位置方可作答</span>
        </div>

        <van-button class="mt-5" block type="primary" size="small" @click="onGetLocation">
          <span>授权地理位置</span>
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'ForceLocation',
  methods: {
    onGetLocation() {
      window.location.reload()
      // this.$bus.$emit('getLocation')
    }
  }
}
</script>
